import React from 'react';

const PageSetting = React.lazy(() => import('pages/PageSetting/PageSetting'));

const PageSettingRoute = [
  {
    path: '/page-setting',
    exact: true,
    name: 'Cài đặt website',
    function: 'SL_PAGE_SETTING_VIEW',
    component: PageSetting,
  },
];

export default PageSettingRoute;
